export class Constants {
    static _instance = new Constants();
    constructor() {
        if (Constants._instance) {
            throw new Error(this.name + ' is a Singleton and can only be accessed through ' + this.name + '.getInstance()');
        }
        Constants._instance = this;
    }
    get FUNCTION_SMART_TAG_ON_READY() {
        return 'onSmartTagReady';
    }
    get name() {
        return 'Constants';
    }
    static getInstance() {
        return Constants._instance;
    }
}
